import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePwa } from '../../features/pwa/PwaProvider';

export function UpdatesSettingsPage() {
  const { t } = useTranslation();
  const { updateAvailable, applyUpdate } = usePwa();
  return (
    <section className="settings-section">
      <h2>{t('settings.updates.title')}</h2>
      <p>{updateAvailable ? t('offline.update.description') : t('offline.update.current')}</p>
      <div className="setting-row"><div><strong>{t('settings.updates.version')}</strong><small>0.1.0</small></div><span className="status-pill" data-tone={updateAvailable ? 'attention' : 'positive'}>{updateAvailable ? t('offline.update.available') : t('offline.update.current')}</span></div>
      {updateAvailable && <button className="button" type="button" onClick={() => void applyUpdate()}><RefreshCw size={17} />{t('offline.update.reload')}</button>}
    </section>
  );
}
